export default {
  menuIsOpen(state) {
    return state.menuIsOpen;
  },
};